import Spinner from '@/components/Spinner';
import { useMediaQuery } from '@/hooks';

import PlanCardUnified from '../PlanCardUnified';
import PlansFeatures from './PlansFeatures/PlansFeatures';
import PlansFeaturesMobile from './PlansFeatures/PlansFeaturesMobile';

function Plans({ plansData, featuresProps = {} }) {
	const { plans, loading } = plansData;

	const mdDown = useMediaQuery('mdDown');

	return (
		<>
			<div className="relative flex min-h-[15rem] flex-col items-center justify-center md:flex-row md:gap-6">
				{loading && (
					<Spinner
						className="absolute inset-0 m-auto text-grey-500"
						size={24}
					/>
				)}

				{!!plans?.length && !loading && (
					<PlanCardUnified plansData={plansData} />
				)}
			</div>

			{mdDown ? (
				<PlansFeaturesMobile plansData={plansData} {...featuresProps} />
			) : (
				<PlansFeatures plansData={plansData} {...featuresProps} />
			)}
		</>
	);
}

export default Plans;
